<template>
	<section class="not-found"></section>
</template>

<script setup></script>

<style scoped lang="scss"></style>
